import { updateListAttribution } from "~/utils/listAttribution";
import { ListAttributes } from "~/models/list";
import { useWTGNList } from "~/hooks/useWTGNList";
import { ErrorMessage } from "~/common/list/ErrorMessage";
import { ListContainer } from "~/common/list/ListContainer";
import Spinner from "~/common/icons/Spinner";
import { ListCards } from "./ListCards";
import { ListViewTitle } from "./ListViewTitle";

export function ListView(props: ListAttributes) {
  const [nonprofits, isError] = useWTGNList(props.listId, props.randomize);

  // any time a list is viewed, update the list attribution cookie
  // this is used to track donations to list eins a user has viewed recently
  updateListAttribution(props.listId);

  if (!nonprofits) {
    return (
      <span className="tw:flex tw:flex-row tw:justify-center tw:items-center">
        <Spinner />
      </span>
    );
  }

  return isError ? (
    <ErrorMessage message={`Error loading list ${props.listName}`} />
  ) : (
    <div className="cn-container-class">
      <ListContainer>
        {props.title && <ListViewTitle title={props.title} />}

        <ListCards listId={props.listId} nonprofits={nonprofits} />
      </ListContainer>
    </div>
  );
}
